import * as types from 'store/mutation-types'

// initial state
const state = {
	permission: {},
	hasPermission:false
}

// actions
const actions = {
  //保存权限
  setpermission ({ commit}, permission) {
    commit(types.SET_PERMISSION, permission)
  },
   //删除权限
  removepermission ({ commit }) {
    commit(types.DEL_PERMISSION)
  },
}

// mutations
const mutations = {
  //保存权限
  [types.SET_PERMISSION] (state, permission) {
  		state.permission=JSON.parse(permission)
  		state.hasPermission = true
  },
  //删除权限
  [types.DEL_PERMISSION] (state) {
  		state.permission={}
  		state.hasPermission = false
  },
}


export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js